export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const CREATE_MOVE = "CREATE_MOVE";
export const EDIT_MOVE = "EDIT_MOVE";
export const EDIT_MOVE_GUILD = "EDIT_MOVE_GUILD";
export const FETCH_MOVES = "FETCH_MOVES";
export const FETCH_MOVE = "FETCH_MOVE";
export const DELETE_MOVE = "DELETE_MOVE";

export const FETCH_USER = 'FETCH_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
